import { render, staticRenderFns } from "./CourseUnitModel.vue?vue&type=template&id=2a0f7530&scoped=true"
import script from "./CourseUnitModel.vue?vue&type=script&lang=js"
export * from "./CourseUnitModel.vue?vue&type=script&lang=js"
import style0 from "./CourseUnitModel.vue?vue&type=style&index=0&id=2a0f7530&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0f7530",
  null
  
)

export default component.exports